import { useEffect, useState } from "react";
import PortfolioList from "../portfolioList/PortfolioList";
import "./portfolio.scss";
import {
  featuredPortfolio,
} from "../../data";
import { Link } from "react-router-dom";

export default function Portfolio() {
  const [selected, setSelected] = useState("featured");
  const [data, setData] = useState([]);


  useEffect(() => {
    switch (selected) {
      case "featured":
        setData(featuredPortfolio);
        break;
      default:
        setData(featuredPortfolio);
    }
  }, [selected]);

  return (
    <div className="portfolio" id="portfolio">
      <h1>Portfolio</h1>
      <ul className="project-types">
        <li>Featured</li>
      </ul>
      <div className="container">
        {featuredPortfolio.map((d) => (
          <div className="item">
            <Link to={`/details/${d.id}`}>
              <img src={d.img} alt={d.title} />
            </Link>
            <h3>{d.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
}
